import { optionsColumn } from '@/global/components/DataGrid/hooks/useDataGridPro'
import { GridColDefPro } from '@/global/components/DataGrid/utils/types'
import Menu from '@/global/components/MenuV2'
import { hasPermission } from '@/hooks/useBackendMenu'
import { SN } from '@acme/core'
import { PencilIcon, Trash2Icon, UserRoundPlusIcon } from 'lucide-react'
import TipoEscala from './tipo'

export const columns: GridColDefPro[] = [
    {
        field: 'id',
        headerName: 'ID',
        hide: true,
    },
    {
        field: 'descricao',
        headerName: 'Escala',
        minWidth: 200,
        flex: 1,
    },
    {
        field: 'horaExtraNoFeriado',
        headerName: 'Hora extra no feriado',
        align: 'center',
        width: 150,
        valueGetter: ({ value }) => SN.format(value),
    },
    {
        field: 'tipo',
        headerName: 'Tipo',
        width: 120,
        align: 'center',
        renderCell: TipoEscala,
    },
    {
        field: 'trabalha',
        headerName: 'Trabalha',
        headerAlign: 'right',
        align: 'right',
        width: 130,
    },
    {
        field: 'folga',
        headerName: 'Folga',
        headerAlign: 'right',
        align: 'right',
        width: 130,
    },
    {
        ...optionsColumn,
        field: '__opcoes',
        type: 'actions',
        getActions: ({ id }) => [
            hasPermission(['read', 'Funcionários'], () => (
                <Menu.Item
                    href={`${id}/funcionarios/`}
                    title="Listar funcionarios"
                    key="funcionarios"
                >
                    <Menu.Item.Icon>
                        <UserRoundPlusIcon />
                    </Menu.Item.Icon>
                    <Menu.Item.Text>Funcionários</Menu.Item.Text>
                </Menu.Item>
            )),
            hasPermission(['update', 'Escalas'], () => (
                <Menu.Item href={`${id}/editar`} key="editar">
                    <Menu.Item.Icon>
                        <PencilIcon />
                    </Menu.Item.Icon>
                    <Menu.Item.Text>Editar</Menu.Item.Text>
                </Menu.Item>
            )),
            hasPermission(['delete', 'Escalas'], () => (
                <Menu.Item href={`${id}/excluir`} key="excluir">
                    <Menu.Item.Icon>
                        <Trash2Icon className="text-error" />
                    </Menu.Item.Icon>
                    <Menu.Item.Text>Excluir</Menu.Item.Text>
                </Menu.Item>
            )),
        ],
    },
]
